import { cpcPatch } from './cpcPatch'
import { cpmPatch } from './cpmPatch'
import { patch } from './patch'

export default {
  ...patch,
  ...cpcPatch,
  ...cpmPatch
}
